import {
  updateCurrentMemberSlug as publicUpdateCurrentMemberSlug,
  updateMemberSlug as publicUpdateMemberSlug,
  joinCommunity as publicJoinCommunity,
  leaveCommunity as publicLeaveCommunity,
  getCurrentMember as publicGetCurrentMember,
  getMember as publicGetMember,
  listMembers as publicListMembers,
  queryMembers as publicQueryMembers,
  typedQueryMembers as publicTypedQueryMembers,
  muteMember as publicMuteMember,
  unmuteMember as publicUnmuteMember,
  approveMember as publicApproveMember,
  blockMember as publicBlockMember,
  disconnectMember as publicDisconnectMember,
  deleteMember as publicDeleteMember,
  deleteMyMember as publicDeleteMyMember,
  bulkDeleteMembers as publicBulkDeleteMembers,
  bulkDeleteMembersByFilter as publicBulkDeleteMembersByFilter,
  bulkApproveMembers as publicBulkApproveMembers,
  bulkBlockMembers as publicBulkBlockMembers,
  createMember as publicCreateMember,
  updateMember as publicUpdateMember,
  deleteMemberPhones as publicDeleteMemberPhones,
  deleteMemberEmails as publicDeleteMemberEmails,
  deleteMemberAddresses as publicDeleteMemberAddresses,
} from './members-v1-member-members.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  MemberQuery,
  MembersQueryBuilder,
  QueryMembersOptions,
  typedQueryMembers as universalTypedQueryMembers,
} from './members-v1-member-members.universal.js';
import { onMemberCreated as publicOnMemberCreated } from './members-v1-member-members.public.js';
import { onMemberDeleted as publicOnMemberDeleted } from './members-v1-member-members.public.js';
import { onMemberUpdated as publicOnMemberUpdated } from './members-v1-member-members.public.js';

function customQueryMembers(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryMembersOptions) =>
      publicQueryMembers(httpClient)(options),
    typedQueryFunction: (query: MemberQuery, options?: QueryMembersOptions) =>
      publicTypedQueryMembers(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: MemberQuery,
    options?: QueryMembersOptions
  ): ReturnType<typeof universalTypedQueryMembers>;
  function overloadedQuery(options?: QueryMembersOptions): MembersQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: MemberQuery | QueryMembersOptions,
    options?: QueryMembersOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const updateCurrentMemberSlug: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCurrentMemberSlug> &
    typeof publicUpdateCurrentMemberSlug
> = /*#__PURE__*/ createRESTModule(publicUpdateCurrentMemberSlug);
export const updateMemberSlug: MaybeContext<
  BuildRESTFunction<typeof publicUpdateMemberSlug> &
    typeof publicUpdateMemberSlug
> = /*#__PURE__*/ createRESTModule(publicUpdateMemberSlug);
export const joinCommunity: MaybeContext<
  BuildRESTFunction<typeof publicJoinCommunity> & typeof publicJoinCommunity
> = /*#__PURE__*/ createRESTModule(publicJoinCommunity);
export const leaveCommunity: MaybeContext<
  BuildRESTFunction<typeof publicLeaveCommunity> & typeof publicLeaveCommunity
> = /*#__PURE__*/ createRESTModule(publicLeaveCommunity);
export const getCurrentMember: MaybeContext<
  BuildRESTFunction<typeof publicGetCurrentMember> &
    typeof publicGetCurrentMember
> = /*#__PURE__*/ createRESTModule(publicGetCurrentMember);
export const getMember: MaybeContext<
  BuildRESTFunction<typeof publicGetMember> & typeof publicGetMember
> = /*#__PURE__*/ createRESTModule(publicGetMember);
export const listMembers: MaybeContext<
  BuildRESTFunction<typeof publicListMembers> & typeof publicListMembers
> = /*#__PURE__*/ createRESTModule(publicListMembers);
export const muteMember: MaybeContext<
  BuildRESTFunction<typeof publicMuteMember> & typeof publicMuteMember
> = /*#__PURE__*/ createRESTModule(publicMuteMember);
export const unmuteMember: MaybeContext<
  BuildRESTFunction<typeof publicUnmuteMember> & typeof publicUnmuteMember
> = /*#__PURE__*/ createRESTModule(publicUnmuteMember);
export const approveMember: MaybeContext<
  BuildRESTFunction<typeof publicApproveMember> & typeof publicApproveMember
> = /*#__PURE__*/ createRESTModule(publicApproveMember);
export const blockMember: MaybeContext<
  BuildRESTFunction<typeof publicBlockMember> & typeof publicBlockMember
> = /*#__PURE__*/ createRESTModule(publicBlockMember);
export const disconnectMember: MaybeContext<
  BuildRESTFunction<typeof publicDisconnectMember> &
    typeof publicDisconnectMember
> = /*#__PURE__*/ createRESTModule(publicDisconnectMember);
export const deleteMember: MaybeContext<
  BuildRESTFunction<typeof publicDeleteMember> & typeof publicDeleteMember
> = /*#__PURE__*/ createRESTModule(publicDeleteMember);
export const deleteMyMember: MaybeContext<
  BuildRESTFunction<typeof publicDeleteMyMember> & typeof publicDeleteMyMember
> = /*#__PURE__*/ createRESTModule(publicDeleteMyMember);
export const bulkDeleteMembers: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteMembers> &
    typeof publicBulkDeleteMembers
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteMembers);
export const bulkDeleteMembersByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteMembersByFilter> &
    typeof publicBulkDeleteMembersByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteMembersByFilter);
export const bulkApproveMembers: MaybeContext<
  BuildRESTFunction<typeof publicBulkApproveMembers> &
    typeof publicBulkApproveMembers
> = /*#__PURE__*/ createRESTModule(publicBulkApproveMembers);
export const bulkBlockMembers: MaybeContext<
  BuildRESTFunction<typeof publicBulkBlockMembers> &
    typeof publicBulkBlockMembers
> = /*#__PURE__*/ createRESTModule(publicBulkBlockMembers);
export const createMember: MaybeContext<
  BuildRESTFunction<typeof publicCreateMember> & typeof publicCreateMember
> = /*#__PURE__*/ createRESTModule(publicCreateMember);
export const updateMember: MaybeContext<
  BuildRESTFunction<typeof publicUpdateMember> & typeof publicUpdateMember
> = /*#__PURE__*/ createRESTModule(publicUpdateMember);
export const deleteMemberPhones: MaybeContext<
  BuildRESTFunction<typeof publicDeleteMemberPhones> &
    typeof publicDeleteMemberPhones
> = /*#__PURE__*/ createRESTModule(publicDeleteMemberPhones);
export const deleteMemberEmails: MaybeContext<
  BuildRESTFunction<typeof publicDeleteMemberEmails> &
    typeof publicDeleteMemberEmails
> = /*#__PURE__*/ createRESTModule(publicDeleteMemberEmails);
export const deleteMemberAddresses: MaybeContext<
  BuildRESTFunction<typeof publicDeleteMemberAddresses> &
    typeof publicDeleteMemberAddresses
> = /*#__PURE__*/ createRESTModule(publicDeleteMemberAddresses);
export const queryMembers: MaybeContext<
  BuildRESTFunction<typeof customQueryMembers> & typeof customQueryMembers
> = /*#__PURE__*/ createRESTModule(customQueryMembers);
/**
 * Triggered when a member is created.
 *
 * The site owner can configure the site to automatically approve members or require manual approval.
 *
 * A member who has been approved either automatically or manually has a `status` of `"APPROVED"`. A created member waiting for approval has a `status` of `"PENDING"`. A `"PENDING"` member can't log in to the site.
 */
export const onMemberCreated: BuildEventDefinition<
  typeof publicOnMemberCreated
> &
  typeof publicOnMemberCreated = createEventModule(publicOnMemberCreated);
/**
 * Triggered when a member is deleted.
 */
export const onMemberDeleted: BuildEventDefinition<
  typeof publicOnMemberDeleted
> &
  typeof publicOnMemberDeleted = createEventModule(publicOnMemberDeleted);
/** */
export const onMemberUpdated: BuildEventDefinition<
  typeof publicOnMemberUpdated
> &
  typeof publicOnMemberUpdated = createEventModule(publicOnMemberUpdated);

export {
  Status,
  PrivacyStatusStatus,
  ActivityStatusStatus,
  Set,
  SortOrder,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  WebhookIdentityType,
} from './members-v1-member-members.universal.js';
export {
  Member,
  Contact,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  CustomField,
  Profile,
  Image,
  ExtendedFields,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  UpdateMySlugRequest,
  UpdateMySlugResponse,
  SlugAlreadyExistsPayload,
  UpdateMemberSlugRequest,
  UpdateMemberSlugResponse,
  JoinCommunityRequest,
  JoinCommunityResponse,
  MemberJoinedCommunity,
  LeaveCommunityRequest,
  LeaveCommunityResponse,
  MemberLeftCommunity,
  GetMyMemberRequest,
  GetMyMemberResponse,
  GetMemberRequest,
  GetMemberResponse,
  MemberToMemberBlockedPayload,
  ListMembersRequest,
  Paging,
  Sorting,
  CursorPaging,
  ListMembersResponse,
  PagingMetadata,
  CursorPagingMetadata,
  Cursors,
  QueryMembersRequest,
  Query,
  Search,
  QueryMembersResponse,
  MuteMemberRequest,
  MuteMemberResponse,
  MemberMuted,
  UnmuteMemberRequest,
  UnmuteMemberResponse,
  MemberUnmuted,
  ApproveMemberRequest,
  ApproveMemberResponse,
  MemberApproved,
  BlockMemberRequest,
  BlockMemberResponse,
  MemberBlocked,
  MemberSelfBlockForbiddenPayload,
  OwnerMemberBlockForbiddenPayload,
  ActiveSubscriptionMemberBlockForbiddenPayload,
  DisconnectMemberRequest,
  DisconnectMemberResponse,
  DeleteMemberRequest,
  DeleteMemberResponse,
  ContentReassignmentRequested,
  ContentDeletionRequested,
  OwnerOrContributorDeleteForbiddenPayload,
  ActiveSubscriptionMemberDeleteForbiddenPayload,
  DeleteMyMemberRequest,
  DeleteMyMemberResponse,
  BulkDeleteMembersRequest,
  BulkDeleteMembersResponse,
  ItemMetadata,
  ApplicationError,
  BulkMemberResult,
  BulkActionMetadata,
  BulkDeleteMembersByFilterRequest,
  BulkDeleteMembersByFilterResponse,
  BulkApproveMembersRequest,
  BulkApproveMembersResponse,
  BulkBlockMembersRequest,
  BulkBlockMembersResponse,
  CreateMemberRequest,
  CreateMemberResponse,
  UpdateMemberRequest,
  UpdateMemberResponse,
  InvalidCustomFieldUrlPayload,
  DeleteMemberPhonesRequest,
  DeleteMemberPhonesResponse,
  DeleteMemberEmailsRequest,
  DeleteMemberEmailsResponse,
  DeleteMemberAddressesRequest,
  DeleteMemberAddressesResponse,
  Empty,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  MemberOwnershipTransferred,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MemberIdChanged,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  MemberCreatedEnvelope,
  MemberDeletedEnvelope,
  MemberUpdatedEnvelope,
  GetCurrentMemberOptions,
  GetMemberOptions,
  ListMembersOptions,
  QueryMembersOptions,
  MembersQueryResult,
  MembersQueryBuilder,
  MemberQuerySpec,
  DeleteMyMemberOptions,
  BulkDeleteMembersByFilterOptions,
  CreateMemberOptions,
  UpdateMember,
} from './members-v1-member-members.universal.js';
export { utils } from './members-v1-member-members.universal.js';
export {
  StatusWithLiterals,
  PrivacyStatusStatusWithLiterals,
  ActivityStatusStatusWithLiterals,
  SetWithLiterals,
  SortOrderWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  UpdateCurrentMemberSlugApplicationErrors,
  UpdateMemberSlugApplicationErrors,
  JoinCommunityApplicationErrors,
  GetCurrentMemberApplicationErrors,
  GetMemberApplicationErrors,
  BlockMemberApplicationErrors,
  DeleteMemberValidationErrors,
  DeleteMyMemberValidationErrors,
  UpdateMemberValidationErrors,
  CommonQueryWithEntityContext,
  MemberQuery,
} from './members-v1-member-members.universal.js';
